import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import NewHeader from "../_components/_global/WelcomeHeader";
const WelcomeScreen = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVH();
    window.addEventListener("resize", setVH);
    window.addEventListener("orientationchange", setVH);
    return () => {
      window.removeEventListener("resize", setVH);
      window.removeEventListener("orientationchange", setVH);
    };
  }, []);

  const handleGetStarted = () => navigate("/city-selection");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <NewHeader scrolled={scrolled} />

      <style>{`
        :root { --card: rgba(255,255,255,.7); --border: rgba(255,255,255,.8); }


.page-wrapper {
          padding-top: 72px; /* 为固定的header留出空间 */
        }


        .mobile-screen{
          width:100%;max-width:430px;
          height:calc(var(--vh,1vh)*100);
          margin:0 auto;background:#f8f9fb;
          display:flex;flex-direction:column;
          position:fixed;top:0;left:50%;transform:translateX(-50%);
          overflow:hidden;
        }
        @media (min-width: 430px){
          .mobile-screen{border-radius:40px;box-shadow:0 10px 40px rgba(0,0,0,.08);}
        }
        .bg-circle-1,.bg-circle-2{position:absolute;border-radius:50%;}
        .bg-circle-1{width:300px;height:300px;background:linear-gradient(135deg,#e6eef5,#eef3f8);top:-160px;right:-120px;opacity:.55;}
        .bg-circle-2{width:220px;height:220px;background:#e9eef3;bottom:-110px;left:-70px;opacity:.35;}

        .screen-content{flex:1;display:flex;flex-direction:column;gap:18px;
          padding:28px 22px 22px;padding-bottom:calc(24px + env(safe-area-inset-bottom,0px));
          overflow:auto;position:relative;z-index:1;}

        .brand{display:flex;align-items:center;gap:12px;margin-top:6px;}
        .logo{width:44px;height:44px;border-radius:16px;background:var(--card);
          backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);
          border:1px solid var(--border);display:flex;align-items:center;justify-content:center;
          box-shadow:0 8px 28px rgba(0,0,0,.05);overflow:hidden;}
        .logo img{width:26px;height:26px;object-fit:contain;}
        .brand h1{font-size:18px;margin:0;color:#14202b;font-weight:700;letter-spacing:.2px;}
        .brand p{margin:0;color:#66788a;font-size:12px;}

        .tag{display:inline-flex;align-items:center;gap:6px;
          background:#eef5ff;color:#2a61ff;border:1px solid #dae7ff;
          font-size:11px;font-weight:600;border-radius:999px;padding:6px 10px;width:max-content;}
        .tag i{font-size:12px;}

        .hero{padding:8px 4px 0;}
        .hero h2{margin:6px 0 6px;font-size:22px;line-height:1.25;color:#0f1720;font-weight:800;letter-spacing:.1px;}
        .hero p{margin:0;color:#5b6b7a;line-height:1.6;font-size:13px;}

        .stats{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-top:10px;}
        .stat{background:var(--card);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);
          border:1px solid var(--border);border-radius:14px;padding:12px 10px;text-align:center;}
        .stat b{display:block;font-size:16px;color:#0f1720;}
        .stat span{display:block;margin-top:2px;color:#687789;font-size:11px;}

        .section-title{margin:2px 0 8px;color:#0f1720;font-weight:700;font-size:14px;}
        .grid-cities{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
        .city{background:#fff;border:1px solid #eef1f4;border-radius:16px;padding:14px 10px;text-align:center;}
        .city .icon{width:34px;height:34px;border-radius:10px;background:#f2f5f8;margin:0 auto 8px;
          display:flex;align-items:center;justify-content:center;}
        .city i{font-size:16px;color:#334454;}
        .city p{margin:0;font-size:12px;color:#0f1720;font-weight:600;}

        .features{display:grid;grid-template-columns:repeat(2,1fr);gap:10px;}
        .feature{background:#fff;border:1px solid #eef1f4;border-radius:16px;padding:14px;}
        .feature .ficon{width:36px;height:36px;border-radius:10px;background:#f3f6ff;
          display:flex;align-items:center;justify-content:center;margin-bottom:10px;}
        .feature i{font-size:16px;color:#2a61ff;}
        .feature h4{margin:4px 0 4px;font-size:13px;color:#0f1720;}
        .feature p{margin:0;color:#5b6b7a;font-size:12px;line-height:1.45;}

        .example{background:#f6fef7;border:1px solid #e1f7e4;border-radius:16px;padding:14px;}
        .example h4{margin:0 0 10px;font-size:13px;color:#0f1720;}
        .check{display:flex;align-items:center;gap:8px;margin:8px 0;color:#1c3f26;font-size:12px;}
        .check i{color:#19a657;font-size:16px;}

        .cta{display:flex;flex-direction:column;gap:10px;margin-top:4px;}
        .cta-card{border-radius:16px;padding:16px;color:#fff;background:#0e2337;}
        .cta-card h5{margin:0 0 6px;font-size:14px;font-weight:700;}
        .cta-card p{margin:0;color:#d5e2ee;font-size:12px;}
        .cta-btn{border:0;border-radius:16px;padding:16px 16px;text-align:left;background:#122a41;
          display:flex;align-items:center;justify-content:space-between;color:#fff;cursor:pointer;}
        .cta-btn span{font-weight:700;}
        .cta-btn i{font-size:16px;}

        .footer{margin-top:2px;text-align:center;color:#7b8a99;font-size:12px;}
      `}</style>

      <div className="mobile-screen">
        <div className="bg-circle-1" />
        <div className="bg-circle-2" />

        <div className="screen-content">
          {/* Brand */}
          <div className="brand">
            <div className="logo">
              <img src="/assets/logocity.jpg" alt="CityGetAway" />
            </div>
            <div>
              <h1>CityGetAway for FIT</h1>
              <p>AI-powered travel assistant</p>
            </div>
          </div>

          {/* Tag */}
          <div className="tag">
            <i className="bi bi-stars" /> AI-driven Trip Assistant
          </div>

          {/* Hero */}
          <div className="hero">
            <h2>Explore the world’s top destinations</h2>
            <p>
              Your AI co-pilot for personalized itineraries and live guidance—
              discover North America and beyond with smarter travel planning.
            </p>
          </div>

          {/* Stats */}
          <div className="stats">
            <div className="stat">
              <b>50K+</b>
              <span>users</span>
            </div>
            <div className="stat">
              <b>1M+</b>
              <span>places</span>
            </div>
            <div className="stat">
              <b>4.9★</b>
              <span>reviews</span>
            </div>
          </div>

          {/* Cities */}
          <div>
            <div className="section-title">Covered Cities</div>
            <div className="grid-cities">
              {[
                ["bi-building", "Toronto"],
                ["bi-buildings", "Vancouver"],
                ["bi-geo-alt", "Montreal"],
                ["bi-building-fill", "New York"],
                ["bi-geo", "Los Angeles"],
                ["bi-globe", "London"],
              ].map(([icon, label]) => (
                <div className="city" key={label}>
                  <div className="icon">
                    <i className={`bi ${icon}`}></i>
                  </div>
                  <p>{label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Core Features */}
          <div>
            <div className="section-title">Core Features</div>
            <div className="features">
              <div className="feature">
                <div className="ficon">
                  <i className="bi bi-magic" />
                </div>
                <h4>AI Smart Planning</h4>
                <p>Create tailored itineraries based on your preferences.</p>
              </div>
              <div className="feature">
                <div className="ficon">
                  <i className="bi bi-send" />
                </div>
                <h4>Live Navigation</h4>
                <p>Seamless city guidance with live tips and updates.</p>
              </div>
              <div className="feature">
                <div className="ficon">
                  <i className="bi bi-people" />
                </div>
                <h4>Travel Community</h4>
                <p>Share trips and discover curated local favorites.</p>
              </div>
              <div className="feature">
                <div className="ficon">
                  <i className="bi bi-globe2" />
                </div>
                <h4>Multi-city Support</h4>
                <p>Major destinations across China—more added regularly.</p>
              </div>
            </div>
          </div>

          {/* Example */}
          <div className="example">
            <h4>Smart Plan Example</h4>
            <div className="check">
              <i className="bi bi-check-circle-fill" /> 3-day deep-dive in
              Montreal
            </div>
            <div className="check">
              <i className="bi bi-check-circle-fill" /> 12 curated landmarks
            </div>
            <div className="check">
              <i className="bi bi-check-circle-fill" /> Budget-friendly options
            </div>
          </div>

          {/* CTA */}
          <div className="cta">
            <div className="cta-card">
              <h5>Ready to explore?</h5>
              <p>
                Join thousands of travelers and find the beauty of Chinese
                cities with AI.
              </p>
            </div>
            <button className="cta-btn" onClick={handleGetStarted}>
              <span>Start my journey</span>
              <i className="bi bi-arrow-right" />
            </button>
          </div>

          <div className="footer">
            Plan smarter. Beautiful trips start here.
          </div>
        </div>
      </div>
    </>
  );
};

export default WelcomeScreen;
